import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./page/Login";
import NotFound from "./page/NotFound";
import Welcome from "./page/Welcome/Welcome";
import ProtectedRoute from "./ProtectedRoute";
import OAuth2 from "./page/OAuth2";
import UnUsedTicketList from "./page/UnUsedTickets/UnUsedTicketList";
import UnUsedTicketDetail from "./page/UnUsedTickets/UnUsedTicketDetail";
import TicketCancel from "./page/TicketCancel/TicketCancel";
import RegisterEmail from "./page/Register/RegisterEmail";
import RegisterPassword from "./page/Register/RegisterPassword";
import RegisterPhone from "./page/Register/RegisterPhone";
import RegisterValidatePhone from "./page/Register/RegisterValidatePhone";
import RegisterValidateEmail from "./page/Register/RegisterValidateEmail";
import RegisterUserInfo from "./page/Register/RegisterUserInfo";
import RegisterTermsService from "./page/Register/RegisterTermsService";
import RegisterRoute from "./RegisterRoute";
import FindAccountNewPassword from "./page/FindAccount/FindAccountNewPassword";
import FindAccountPhoneNum from "./page/FindAccount/FindAccountPhoneNum";
import FindAccountValidatePhone from "./page/FindAccount/FindAccountValidatePhone";
import MyTicketList from "./page/MyTickets/MyTicketList";
import TicketDetail from "./page/MyTickets/TicketDetail";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/login" element={<Login />}></Route>

        {/* 계정찾기 Route */}
        <Route path="/find-account" element={<FindAccountPhoneNum />} />
        <Route
          path="/find-account/validate"
          element={<FindAccountValidatePhone />}
        />
        <Route
          path="/find-account/password"
          element={<FindAccountNewPassword />}
        ></Route>

        {/* 회원가입 Route */}
        <Route path="/register" element={<RegisterTermsService />} />
        <Route
          path="/register/phone/validate"
          element={
            <RegisterRoute>
              <RegisterValidatePhone />
            </RegisterRoute>
          }
        ></Route>
        <Route
          path="/register/username/validate"
          element={
            <RegisterRoute>
              <RegisterValidateEmail />
            </RegisterRoute>
          }
        ></Route>
        <Route path="/register/info" element={<RegisterUserInfo />}></Route>
        <Route path="/login/authentication" element={<OAuth2 />} />
        <Route path="/register/username" element={<RegisterEmail />} />
        <Route
          path="/register/password"
          element={
            <RegisterRoute>
              <RegisterPassword />
            </RegisterRoute>
          }
        />
        <Route
          path="/register/phone"
          element={
            <RegisterRoute>
              <RegisterPhone />
            </RegisterRoute>
          }
        />

        {/* 티켓조회 Route */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Welcome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-tickets"
          element={
            <ProtectedRoute>
              <MyTicketList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-tickets/:pk"
          element={
            <ProtectedRoute>
              <TicketDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-tickets/:pk/cancel"
          element={
            <ProtectedRoute>
              <TicketCancel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
